import { render, staticRenderFns } from "./AccountEditModal.vue?vue&type=template&id=72708bd8&"
import script from "./AccountEditModal.vue?vue&type=script&lang=ts&"
export * from "./AccountEditModal.vue?vue&type=script&lang=ts&"
import style0 from "./AccountEditModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports